import { Box, Typography } from "@mui/material";
import type { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import BadgeDetached from "@entrilia/shared/components/BadgeDetached";
import CompanyTypeBadge from "@entrilia/shared/components/CompanyTypeBadge.tsx";
import ExpandCollapseAllButton from "@entrilia/shared/components/ExpandCollapseAllButton";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import type { ClientInfo } from "../../../api/types/clientTypes";
import { ExpandCollapseButton } from "../reporting/report-lists/reports/components/ExpandCollapseButton.tsx";
import ClientLogo from "./ClientLogo";

export const GroupHeader = ({ headerName }: { headerName: string | undefined }) => {
  return (
    <>
      <ExpandCollapseAllButton />
      <Typography variant="subtitle2" sx={{ pl: 0.75 }}>
        {headerName}
      </Typography>
    </>
  );
};

export const GroupName = ({ params }: { params: GridRenderCellParams }) => {
  const apiRef = useGridApiContext();
  const expanded = params.rowNode.type === "group" && params.rowNode.childrenExpanded === true;

  return (
    <>
      <ExpandCollapseButton
        expanded={expanded}
        onClick={(value) => {
          apiRef.current?.setRowChildrenExpansion(params.id, value);
        }}
      />
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, pl: 1 }}>
        <Typography variant="subtitle2">{params.value || "Unmanaged"}</Typography>
        <BadgeDetached
          badgeContent={params.rowNode.type === "group" && params.rowNode.children.length}
          color="secondary"
          sx={(t) => ({ color: t.palette.secondary.main })}
        />
      </Box>
    </>
  );
};

export const NameColumn = ({ company }: { company: ClientInfo }) => {
  return (
    <GridTextHoverLink to={`/${company.clientCode}`}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", pl: 6, maxWidth: "100%" }}>
        {company.branding.logoMarkUrl && <ClientLogo size="small" logoSrc={company.branding.logoMarkUrl} />}
        <Typography variant="subtitle2" noWrap>
          {company.title}
        </Typography>
        {company.companyType && <CompanyTypeBadge type={company.companyType} />}
      </Box>
    </GridTextHoverLink>
  );
};
